import { Link } from 'react-router-dom';
import { useBranding } from '../context/BrandingContext';

/**
 * Public stub for the Terms of Use. Replace with counsel-approved copy before launch.
 */
export default function TermsPage() {
  const { branding } = useBranding();
  const productName = branding.productName || 'inkedform';
  const year = new Date().getFullYear();

  return (
    <main style={styles.page}>
      <article style={styles.card}>
        <p style={styles.eyebrow}>
          <Link to="/login" style={styles.back}>← Back to sign in</Link>
        </p>
        <h1 style={styles.title}>Terms of Use</h1>
        <p style={styles.lede}>
          This page is a placeholder for the {productName} Terms of Use.
          The live terms text has not been published yet.
        </p>
        <div style={styles.body}>
          <p>
            These Terms of Use will govern access to {productName} for customer
            organisation staff and administrators. The placeholder exists so the
            sign-in page can already link to a stable URL. This draft is not the
            binding terms and will be replaced with counsel-approved copy before
            public launch.
          </p>
          <p style={{ marginTop: 14 }}>
            Questions about an account or organisation subscription:{' '}
            <a href="mailto:support@inkedform.com">support@inkedform.com</a>.
          </p>
        </div>
        <p style={styles.meta}>© {year} {productName}</p>
      </article>
    </main>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '48px 16px',
    background: 'linear-gradient(135deg, #f0f4f8 0%, #e8eef3 50%, #dce5ed 100%)',
    fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
    boxSizing: 'border-box',
  },
  card: {
    background: '#fff',
    width: '100%',
    maxWidth: 720,
    borderRadius: 16,
    padding: '36px 32px',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08), 0 1px 4px rgba(0,0,0,0.04)',
  },
  eyebrow: { margin: '0 0 18px', fontSize: 13 },
  back: { color: '#16c1d5', textDecoration: 'none', fontWeight: 600 },
  title: { margin: '0 0 12px', fontSize: 28, color: '#0f172a' },
  lede: { margin: '0 0 20px', color: '#4b5563', lineHeight: 1.6, fontSize: 15 },
  body: { color: '#374151', fontSize: 14, lineHeight: 1.7 },
  meta: { marginTop: 28, fontSize: 12, color: '#9ca3af' },
};
